import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { Select } from "@ngxs/store";
import { Observable } from "rxjs";
import { AppState } from "src/app/app.state";
import { InspectionTypeSummary } from "src/app/models/inspection-type-summary.model";
import { TripStartOrEnd } from "src/app/models/mir-rule.model";
import { LanguageDictionaryService } from "src/app/services/language-dictionary/language-dictionary.service";
import { RulesService } from "src/app/services/rules/rules.service";

@Component({
	selector: "app-trip-start-end",
	templateUrl: "./trip-start-end.component.html",
	styleUrls: ["./trip-start-end.component.scss"],
})
export class TripStartEndComponent implements OnInit, OnChanges {
	constructor(private rulesService: RulesService, private langService: LanguageDictionaryService) {}

	@Input() tripStartOrEnd: TripStartOrEnd = null;
	@Input() tripZones = "None";
	@Select(AppState.selectInspectionTypes)
	inspectionTypes: Observable<InspectionTypeSummary[]>;

	private latestInspectionTypes: InspectionTypeSummary[] = [];

	tripInspectionTypes: string = null;

	zonesTripTypes = ["exit_zone", "enter_zone"];

	ngOnInit(): void {
		this.inspectionTypes?.subscribe(types => {
			this.latestInspectionTypes = types ?? [];
			if (this.tripStartOrEnd) {
				this.tripInspectionTypes = this.getInspectionNames();
			}
		});
	}

	translateIntsToDays(ints: number[]): string {
		return ints
			.map(int => {
				return this.rulesService.intToDay(int) || "Unknown Day";
			})
			.join(", ")
			.trim();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes?.tripStartOrEnd?.currentValue) {
			this.tripStartOrEnd = changes.tripStartOrEnd.currentValue;
			this.tripInspectionTypes = this.getInspectionNames();
		}
	}

	formatStringForDisplay(term: string): string {
		return term
			.split("_")
			.map(word => `${word[0].toLocaleUpperCase()}${word.slice(1)}`)
			.join(" ");
	}

	getInspectionNames(): string {
		return this.tripStartOrEnd.inspectionTypes
			.map(insp => {
				const match = this.latestInspectionTypes.find(t => t.inspectionTypeId === insp.inspectionType);
				return (match && this.langService.getTranslation(match.langId)) || "Unknown Inspection Type";
			})
			.join(", ")
			.trim();
	}
}
